import React from 'react';
import PropTypes from 'prop-types';

import { states, stateClassNames } from './transitionStates';

export default class BrorTransitionTarget extends React.Component {
  static propTypes = {
    transitionState: PropTypes.arrayOf(PropTypes.oneOf(Object.values(states))),
  };

  getTransitionClassNames() {
    if (!this.classNames) {
      throw new Error(
        'TransitionTarget instances must have a classNames property'
      );
    }

    const { transitionState } = this.props;

    return (
      (transitionState &&
        stateClassNames[transitionState]
          .map(className => this.classNames[className])
          .filter(Boolean)) ||
      null
    );
  }
}
